// A sheep, modelled facing +X: a fluffy cream wool body on dark stick legs with a
// small dark face. Ported 1:1 from age-of-mcp's classic sheep.ts, restoring its
// leg loop + body/head/ear composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.05, 0.03], [0.05, -0.03], [-0.05, 0.03], [-0.05, -0.03]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.006, 0.005, 0.092, 4),
      color: "#2c2c2c", position: [x!, 0.046, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#ede6d8",
      position: [0, 0.092, 0], scale: [1.6, 1.1, 1.05] },             // woolly body
    { geometry: new THREE.IcosahedronGeometry(0.024, 0), color: "#3a3530",
      position: [0.085, 0.092, 0], scale: [1.1, 1.2, 0.9] },          // head
    { geometry: new THREE.IcosahedronGeometry(0.01, 0), color: "#2c2c2c",
      position: [0.075, 0.115, 0.018], scale: [0.7, 1.4, 0.6] },      // ear
    { geometry: new THREE.IcosahedronGeometry(0.01, 0), color: "#2c2c2c",
      position: [0.075, 0.115, -0.018], scale: [0.7, 1.4, 0.6] },
  );
  return parts;
}

export const sheep = defineModel({
  id: "sheep",
  scale: 2.47, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Sheep",
  tags: ["creature","sheep","low-poly","age-of-mcp","classic"],
  summary: "Low-poly sheep.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.13,
  parts: () => partsFor(),
  animations: [],
});
